import { render, staticRenderFns } from "./simplifyOwnerMember.vue?vue&type=template&id=04c65e12&scoped=true"
import script from "./simplifyOwnerMember.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerMember.vue?vue&type=script&lang=js"
import style0 from "./simplifyOwnerMember.vue?vue&type=style&index=0&id=04c65e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c65e12",
  null
  
)

export default component.exports